//This is for adding a player to the system that is NOT already in the system.
//This is NOT for adding an alread-existing player to a team.
import React, { useState } from 'react'
import AdminNavigation from '../../admin/components/AdminNavigation'
import './NewPlayerForm.css'
import '../../admin/games/AddGamesForm.css'
//import Button from '../../shared/components/UIElements/Button'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import { useNavigate, useLocation, useParams } from 'react-router-dom'

const BrandNewPlayerFormForUnfounds = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [firstName1, setFirstName1] = useState()
	const [middleInitial1, setMiddleInitial1] = useState()
	const [lastName1, setLastName1] = useState()
	const [firstName2, setFirstName2] = useState()
	const [middleInitial2, setMiddleInitial2] = useState()
	const [lastName2, setLastName2] = useState()
	const [firstName3, setFirstName3] = useState()
	const [middleInitial3, setMiddleInitial3] = useState()
	const [lastName3, setLastName3] = useState()
	const [firstName4, setFirstName4] = useState()
	const [middleInitial4, setMiddleInitial4] = useState()
	const [lastName4, setLastName4] = useState()
	const [firstName5, setFirstName5] = useState()
	const [middleInitial5, setMiddleInitial5] = useState()
	const [lastName5, setLastName5] = useState()
	const [firstName6, setFirstName6] = useState()
	const [middleInitial6, setMiddleInitial6] = useState()
	const [lastName6, setLastName6] = useState()
	const [firstName7, setFirstName7] = useState()
	const [middleInitial7, setMiddleInitial7] = useState()
	const [lastName7, setLastName7] = useState()
	const [firstName8, setFirstName8] = useState()
	const [middleInitial8, setMiddleInitial8] = useState()
	const [lastName8, setLastName8] = useState()
	const [firstName9, setFirstName9] = useState()
	const [middleInitial9, setMiddleInitial9] = useState()
	const [lastName9, setLastName9] = useState()
	const [firstName10, setFirstName10] = useState()
	const [middleInitial10, setMiddleInitial10] = useState()
	const [lastName10, setLastName10] = useState()
	/* const [jerseyNumber1, setJerseyNumber1] = useState()
	const [jerseyNumber2, setJerseyNumber2] = useState()
	const [jerseyNumber3, setJerseyNumber3] = useState()
	const [jerseyNumber4, setJerseyNumber4] = useState()
	const [jerseyNumber5, setJerseyNumber5] = useState()
	const [jerseyNumber6, setJerseyNumber6] = useState()
	const [jerseyNumber7, setJerseyNumber7] = useState()
	const [jerseyNumber8, setJerseyNumber8] = useState()
	const [jerseyNumber9, setJerseyNumber9] = useState()
	const [jerseyNumber10, setJerseyNumber10] = useState() */
	//
	/* const [usabh1, setUsabh1] = useState()
	const [usabh2, setUsabh2] = useState()
	const [usabh3, setUsabh3] = useState()
	const [usabh4, setUsabh4] = useState()
	const [usabh5, setUsabh5] = useState()
	const [usabh6, setUsabh6] = useState()
	const [usabh7, setUsabh7] = useState()
	const [usabh8, setUsabh8] = useState()
	const [usabh9, setUsabh9] = useState()
	const [usabh10, setUsabh10] = useState() */
	let navigate = useNavigate()

	const leagueName = useParams().leagueName
	const year = useParams().year
	const divisionId = useParams().divisionId
	const teamName = useParams().teamName
	const teamId = useParams().teamId
	const location = useLocation()
	const unfounds = location.state?.unfounds

	console.log('we got some unfounds here:  ' + unfounds)
	console.log('teamId: ' + teamId)

	//
	// Since we have some unfounds here, I am going to make THREE different damn arrays
	//  The first array is of isGoalie
	//  The second array is of jersey numbers
	//  The third array is of usabh numbers
	//
	let isGoalieArray = []
	let jerseyNumberArray = []
	let usabhArray = []

	unfounds.forEach((unfound) => {
		const split = unfound.split('|')
		const isGoalie = split[0]
		const jerseyNumber = split[1]
		const usabh = split[2]

		isGoalieArray.push(isGoalie)
		jerseyNumberArray.push(jerseyNumber)
		usabhArray.push(usabh)
	})

	const playerSubmitHandler = async (event) => {
		event.preventDefault()

		let usabh1,
			usabh2,
			usabh3,
			usabh4,
			usabh5,
			usabh6,
			usabh7,
			usabh8,
			usabh9,
			usabh10,
			jerseyNumber1,
			jerseyNumber2,
			jerseyNumber3,
			jerseyNumber4,
			jerseyNumber5,
			jerseyNumber6,
			jerseyNumber7,
			jerseyNumber8,
			jerseyNumber9,
			jerseyNumber10,
			isGoalie1,
			isGoalie2,
			isGoalie3,
			isGoalie4,
			isGoalie5,
			isGoalie6,
			isGoalie7,
			isGoalie8,
			isGoalie9,
			isGoalie10

		jerseyNumber1 = jerseyNumberArray[0]
		jerseyNumber2 = jerseyNumberArray[1]
		jerseyNumber3 = jerseyNumberArray[2]
		jerseyNumber4 = jerseyNumberArray[3]
		jerseyNumber5 = jerseyNumberArray[4]
		jerseyNumber6 = jerseyNumberArray[5]
		jerseyNumber7 = jerseyNumberArray[6]
		jerseyNumber8 = jerseyNumberArray[7]
		jerseyNumber9 = jerseyNumberArray[8]
		jerseyNumber10 = jerseyNumberArray[9]

		usabh1 = usabhArray[0]
		usabh2 = usabhArray[1]
		usabh3 = usabhArray[2]
		usabh4 = usabhArray[3]
		usabh5 = usabhArray[4]
		usabh6 = usabhArray[5]
		usabh7 = usabhArray[6]
		usabh8 = usabhArray[7]
		usabh9 = usabhArray[8]
		usabh10 = usabhArray[9]

		isGoalie1 = isGoalieArray[0]
		isGoalie2 = isGoalieArray[1]
		isGoalie3 = isGoalieArray[2]
		isGoalie4 = isGoalieArray[3]
		isGoalie5 = isGoalieArray[4]
		isGoalie6 = isGoalieArray[5]
		isGoalie7 = isGoalieArray[6]
		isGoalie8 = isGoalieArray[7]
		isGoalie9 = isGoalieArray[8]
		isGoalie10 = isGoalieArray[9]

		try {
			setIsLoading(true)
			const response = await fetch(
				process.env.REACT_APP_BACKEND_URL +
					`/admin/${teamId}/newPlayerFromUnfounds`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						firstName1,
						middleInitial1,
						lastName1,
						firstName2,
						middleInitial2,
						lastName2,
						firstName3,
						middleInitial3,
						lastName3,
						firstName4,
						middleInitial4,
						lastName4,
						firstName5,
						middleInitial5,
						lastName5,
						firstName6,
						middleInitial6,
						lastName6,
						firstName7,
						middleInitial7,
						lastName7,
						firstName8,
						middleInitial8,
						lastName8,
						firstName9,
						middleInitial9,
						lastName9,
						firstName10,
						middleInitial10,
						lastName10,
						usabh1,
						usabh2,
						usabh3,
						usabh4,
						usabh5,
						usabh6,
						usabh7,
						usabh8,
						usabh9,
						usabh10,
						jerseyNumber1,
						jerseyNumber2,
						jerseyNumber3,
						jerseyNumber4,
						jerseyNumber5,
						jerseyNumber6,
						jerseyNumber7,
						jerseyNumber8,
						jerseyNumber9,
						jerseyNumber10,
						isGoalie1,
						isGoalie2,
						isGoalie3,
						isGoalie4,
						isGoalie5,
						isGoalie6,
						isGoalie7,
						isGoalie8,
						isGoalie9,
						isGoalie10,
					}),
				},
			)
			const responseData = await response.json()
			if (!response.ok) {
				throw new Error(responseData.message)
			}
			setIsLoading(false)
			//navigate('/admin/leagues/current')
			navigate(`/admin/${leagueName}/${year}/${divisionId}/${teamName}/players`)
		} catch (err) {
			setIsLoading(false)
			setError(
				err.message ||
					'Something went wrong with creating a new player from unfounds',
			)
		}
	}

	const errorHandler = () => {
		setError(null)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{/* <div> */}
			{isLoading && <LoadingSpinner asOverlay />}
			<AdminNavigation />
			<main style={{ height: '1200px' }}>
				<h2>Add NOT FOUND Players to the System</h2>
				<p style={{ textAlign: 'center' }}>
					Please enter the first and last names for these not found players.
				</p>
				<p style={{ textAlign: 'center' }}>
					When finished, click 'Submit' and they'll be added to the System, and
					to the Team.
				</p>
				<form
					className='AddPlayers'
					style={{ marginRight: 'auto', marginLeft: 'auto' }}
					onSubmit={playerSubmitHandler}
				>
					<table id='games'>
						<thead>
							<tr>
								<th>First Name</th>
								<th>Middle Initial</th>
								<th>Last Name</th>
								{/* <th>Jersey Number</th> */}
								{/* <th>Goalie?</th> */}
								<th>USA Ball Hockey Number</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									<input
										placeholder={'1:'}
										id='firstName1'
										type='text'
										onChange={(e) => setFirstName1(e.target.value)}
									/>
								</td>
								<td>
									<input
										style={{ width: '30%' }}
										id='middleInitial1'
										maxLength='1'
										type='text'
										onChange={(e) => setMiddleInitial1(e.target.value)}
									/>
								</td>
								<td>
									<input
										id='lastName1'
										type='text'
										onChange={(e) => setLastName1(e.target.value)}
									/>
								</td>
								{/* <td>
									<input
										style={{ width: '30%' }}
										id='jerseynumber1'
										type='number'
										maxLength='2'
										max='99'
										onChange={(e) => setJerseyNumber1(e.target.value)}
										default={jerseyNumberArray[0]}
									/>
								</td> */}
								<td>
									<input
										id='usabh1'
										type='text'
										readOnly
										//onChange={(e) => setUsabh1(e.target.value)}
										defaultValue={usabhArray[0]}
									/>
								</td>
							</tr>
							<tr>
								<td>
									<input
										placeholder={'2:'}
										id='firstName2'
										type='text'
										onChange={(e) => setFirstName2(e.target.value)}
									/>
								</td>
								<td>
									<input
										style={{ width: '30%' }}
										id='middleInitial2'
										maxLength='1'
										type='text'
										onChange={(e) => setMiddleInitial2(e.target.value)}
									/>
								</td>
								<td>
									<input
										id='lastName2'
										type='text'
										onChange={(e) => setLastName2(e.target.value)}
									/>
								</td>
								{/* <td>
									<input
										style={{ width: '30%' }}
										maxLength='2'
										max='99'
										id='jerseynumber2'
										type='number'
										onChange={(e) => setJerseyNumber2(e.target.value)}
									/>
								</td> */}
								<td>
									<input
										id='usabh2'
										type='text'
										readOnly
										//onChange={(e) => setUsabh2(e.target.value)}
										defaultValue={usabhArray[1]}
									/>
								</td>
							</tr>
							<tr>
								<td>
									<input
										placeholder={'3:'}
										id='firstName3'
										type='text'
										onChange={(e) => setFirstName3(e.target.value)}
									/>
								</td>
								<td>
									<input
										style={{ width: '30%' }}
										id='middleInitial3'
										maxLength='1'
										type='text'
										onChange={(e) => setMiddleInitial3(e.target.value)}
									/>
								</td>
								<td>
									<input
										id='lastName3'
										type='text'
										onChange={(e) => setLastName3(e.target.value)}
									/>
								</td>
								{/* <td>
									<input
										style={{ width: '30%' }}
										maxLength='2'
										max='99'
										id='jerseynumber3'
										type='number'
										onChange={(e) => setJerseyNumber3(e.target.value)}
									/>
								</td> */}
								<td>
									<input
										id='usabh3'
										type='text'
										readOnly
										//onChange={(e) => setUsabh3(e.target.value)}
										defaultValue={usabhArray[2]}
									/>
								</td>
							</tr>
							<tr>
								<td>
									<input
										placeholder={'4:'}
										id='firstName4'
										type='text'
										onChange={(e) => setFirstName4(e.target.value)}
									/>
								</td>
								<td>
									<input
										style={{ width: '30%' }}
										id='middleInitial4'
										maxLength='1'
										type='text'
										onChange={(e) => setMiddleInitial4(e.target.value)}
									/>
								</td>
								<td>
									<input
										id='lastName4'
										type='text'
										onChange={(e) => setLastName4(e.target.value)}
									/>
								</td>
								{/* <td>
									<input
										style={{ width: '30%' }}
										maxLength='2'
										max='99'
										id='jerseynumber4'
										type='number'
										onChange={(e) => setJerseyNumber4(e.target.value)}
									/>
								</td> */}
								<td>
									<input
										id='usabh4'
										type='text'
										readOnly
										//onChange={(e) => setUsabh4(e.target.value)}
										defaultValue={usabhArray[3]}
									/>
								</td>
							</tr>
							<tr>
								<td>
									<input
										placeholder={'5:'}
										id='firstName5'
										type='text'
										onChange={(e) => setFirstName5(e.target.value)}
									/>
								</td>
								<td>
									<input
										style={{ width: '30%' }}
										id='middleInitial5'
										maxLength='1'
										type='text'
										onChange={(e) => setMiddleInitial5(e.target.value)}
									/>
								</td>
								<td>
									<input
										id='lastName5'
										type='text'
										onChange={(e) => setLastName5(e.target.value)}
									/>
								</td>
								{/* <td>
									<input
										style={{ width: '30%' }}
										maxLength='2'
										max='99'
										id='jerseynumber5'
										type='number'
										onChange={(e) => setJerseyNumber5(e.target.value)}
									/>
								</td> */}
								<td>
									<input
										id='usabh5'
										type='text'
										readOnly
										//onChange={(e) => setUsabh5(e.target.value)}
										defaultValue={usabhArray[4]}
									/>
								</td>
							</tr>
							<tr>
								<td>
									<input
										placeholder={'6:'}
										id='firstName6'
										type='text'
										onChange={(e) => setFirstName6(e.target.value)}
									/>
								</td>
								<td>
									<input
										style={{ width: '30%' }}
										id='middleInitial6'
										maxLength='1'
										type='text'
										onChange={(e) => setMiddleInitial6(e.target.value)}
									/>
								</td>
								<td>
									<input
										id='lastName6'
										type='text'
										onChange={(e) => setLastName6(e.target.value)}
									/>
								</td>
								{/* <td>
									<input
										style={{ width: '30%' }}
										maxLength='2'
										max='99'
										id='jerseynumber6'
										type='number'
										onChange={(e) => setJerseyNumber6(e.target.value)}
									/>
								</td> */}
								<td>
									<input
										id='usabh6'
										type='text'
										readOnly
										//onChange={(e) => setUsabh6(e.target.value)}
										defaultValue={usabhArray[5]}
									/>
								</td>
							</tr>
							<tr>
								<td>
									<input
										placeholder={'7:'}
										id='firstName7'
										type='text'
										onChange={(e) => setFirstName7(e.target.value)}
									/>
								</td>
								<td>
									<input
										style={{ width: '30%' }}
										id='middleInitial7'
										maxLength='1'
										type='text'
										onChange={(e) => setMiddleInitial7(e.target.value)}
									/>
								</td>
								<td>
									<input
										id='lastName7'
										type='text'
										onChange={(e) => setLastName7(e.target.value)}
									/>
								</td>
								{/* <td>
									<input
										style={{ width: '30%' }}
										maxLength='2'
										max='99'
										id='jerseynumber7'
										type='number'
										onChange={(e) => setJerseyNumber7(e.target.value)}
									/>
								</td> */}
								<td>
									<input
										id='usabh7'
										type='text'
										readOnly
										//onChange={(e) => setUsabh7(e.target.value)}
										defaultValue={usabhArray[6]}
									/>
								</td>
							</tr>
							<tr>
								<td>
									<input
										placeholder={'8:'}
										id='firstName8'
										type='text'
										onChange={(e) => setFirstName8(e.target.value)}
									/>
								</td>
								<td>
									<input
										style={{ width: '30%' }}
										id='middleInitial8'
										maxLength='1'
										type='text'
										onChange={(e) => setMiddleInitial8(e.target.value)}
									/>
								</td>
								<td>
									<input
										id='lastName8'
										type='text'
										onChange={(e) => setLastName8(e.target.value)}
									/>
								</td>
								{/* <td>
									<input
										style={{ width: '30%' }}
										maxLength='2'
										max='99'
										id='jerseynumber8'
										type='number'
										onChange={(e) => setJerseyNumber8(e.target.value)}
									/>
								</td> */}
								<td>
									<input
										id='usabh8'
										type='text'
										readOnly
										//onChange={(e) => setUsabh8(e.target.value)}
										defaultValue={usabhArray[7]}
									/>
								</td>
							</tr>
							<tr>
								<td>
									<input
										placeholder={'9:'}
										id='firstName9'
										type='text'
										onChange={(e) => setFirstName9(e.target.value)}
									/>
								</td>
								<td>
									<input
										style={{ width: '30%' }}
										id='middleInitial9'
										maxLength='1'
										type='text'
										onChange={(e) => setMiddleInitial9(e.target.value)}
									/>
								</td>
								<td>
									<input
										id='lastName9'
										type='text'
										onChange={(e) => setLastName9(e.target.value)}
									/>
								</td>
								{/* <td>
									<input
										style={{ width: '30%' }}
										maxLength='2'
										max='99'
										id='jerseynumber9'
										type='number'
										onChange={(e) => setJerseyNumber9(e.target.value)}
									/>
								</td> */}
								<td>
									<input
										id='usabh9'
										type='text'
										readOnly
										//onChange={(e) => setUsabh9(e.target.value)}
										defaultValue={usabhArray[8]}
									/>
								</td>
							</tr>
							<tr>
								<td>
									<input
										placeholder={'10:'}
										id='firstName10'
										type='text'
										onChange={(e) => setFirstName10(e.target.value)}
									/>
								</td>
								<td>
									<input
										style={{ width: '30%' }}
										id='middleInitial10'
										maxLength='1'
										type='text'
										onChange={(e) => setMiddleInitial10(e.target.value)}
									/>
								</td>
								<td>
									<input
										id='lastName10'
										type='text'
										onChange={(e) => setLastName10(e.target.value)}
									/>
								</td>
								{/* <td>
									<input
										style={{ width: '30%' }}
										maxLength='2'
										max='99'
										id='jerseynumber10'
										type='number'
										onChange={(e) => setJerseyNumber10(e.target.value)}
									/>
								</td> */}
								<td>
									<input
										id='usabh10'
										type='text'
										readOnly
										//onChange={(e) => setUsabh10(e.target.value)}
										defaultValue={usabhArray[9]}
									/>
								</td>
							</tr>
						</tbody>
						<div style={{ width: '150%', marginTop: '1rem' }}>
							{/* <Button type='submit'>ADD PLAYER(S)</Button> */}
							<AdminButton
								type='submit'
								disabled={
									firstName1 && !lastName1
										? true
										: false || (firstName2 && !lastName2)
											? true
											: false || (firstName3 && !lastName3)
												? true
												: false || (firstName4 && !lastName4)
													? true
													: false || (firstName5 && !lastName5)
														? true
														: false || (firstName6 && !lastName6)
															? true
															: false || (firstName7 && !lastName7)
																? true
																: false || (firstName8 && !lastName8)
																	? true
																	: false || (firstName9 && !lastName9)
																		? true
																		: false || (firstName10 && !lastName10)
																			? true
																			: false || (!firstName1 && !lastName1)
																				? true
																				: false
								}
							>
								SUBMIT
							</AdminButton>
						</div>
					</table>
				</form>
			</main>
		</React.Fragment>
	)
}

export default BrandNewPlayerFormForUnfounds
